import { createContext } from 'react'
import type { LeadRefetchContextType } from './leadRefetch.types'

export const LeadRefetchContext = createContext<
  LeadRefetchContextType | undefined
>(undefined)
